import React from "react";
import Header from "../components/Header";
import BookingForm from "../components/BookingForm";

export default function SafariBookingPage() {

  return (
    <>
      <Header />

      <div className="seo-page">

        <h1>
          Ranthambore Safari Booking Online
        </h1>

        <p>
          Book Ranthambore Tiger Safari online with high confirmation rate. Choose Jeep Safari or Canter Safari easily.
        </p>

        <BookingForm />

      </div>
    </>
  );
}
